export type HeroVectorColors = {
  light: string;
  dark: string;
  orange: string;
  blue: string;
  red: string;
};

export const heroVectorColors: Record<'light' | 'dark', HeroVectorColors> = {
  light: {
    light: '#fff',
    dark: '#1c2026',
    orange: '#e96244',
    blue: '#2e83f4',
    red: '#ff003d',
  },
  dark: {
    light: '#dce8f5',
    dark: '#2f3446',
    orange: '#ff8a70',
    blue: '#2e83f4',
    red: '#ff496d',
  },
};
